export default __webpack_public_path__ + "static/media/Kuthcheman Cultist Shield.63beeefa.jpg";